import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FichaService } from "../../services/ficha.service";

import { ViewFichaEntidade } from "../../components/viewFichaEntidade";


export function UserView() {
  const { id } = useParams();

  const [entidade, setEntidade] = useState({
    cpf: "",
    nome: "",
    chefeImediato: "",
    statusAutorizacaoChefeImediato: "",
    nomeAutorizadorComissaoSip3w: "",
    statusAutorizacaoComissaoSip3w: "",
    nomeAutorizadorInteligencia: "",
    statusAutorizacaoInteligencia: "",
    orgaoAutorizacaoInteligencia: "",
    nomeAutorizadorSecretario: "",
    statusAutorizacaoSecretario: "",
    nomeFuncCotic: "",
    dataAtualizacaoChefeImediato: null,
    dataAtualizacaoSecretario: null,
    statusFuncCotic: "",
    sistema: "",
  });

  const load = useCallback(async () => {
    if (id) {
      const { data } = await FichaService.getIdUser({ id });
      setEntidade(data);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ViewFichaEntidade entidade={entidade} />
  );


}
